import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresAgregar', {
    template: template,
    controller: NominasNominaColaboradoresAgregarComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      empleados: '<',
      onClose: '&',
      onChange: '&',
    },
  })

function NominasNominaColaboradoresAgregarComponent($parse, $catalogos, NominasNominaColaboradores) {
  let $ctrl = this

  $ctrl.$onChanges = $onChanges
  $ctrl.$onInit = $onInit
  $ctrl.agregar = agregar
  $ctrl.cerrar = cerrar

  function $onInit() {
    $ctrl.modalidad = null
    $ctrl.desconocidos = []
  }

  function $onChanges(changes) {
    if (changes.empleados) {
      $ctrl.empleados = angular.copy($ctrl.empleados)

      $ctrl.agregados = $ctrl.empleados.map(function (item) {
        return item.id_empleado + '@' + item.id_empresa
      })
    }
  }

  function agregar(data) {
    if (!data) {
      cerrar()

      return
    }

    $ctrl.modalidad = null
    $ctrl.desconocidos = []
    $ctrl.duplicados = []

    // Revisar si hay registros sin vincular con un empleados
    $ctrl.desconocidos = data.filter(function (item) {
      return !item.id_empresa || !item.id_empleado
    })

    if ($ctrl.desconocidos.length)
      return

    $ctrl.actualizando = true

    // Juntar duplicados
    data = unificarColaboradores(data)

    return $catalogos.get('movimientos')
      .then(function (conceptos) {
        $ctrl.conceptos = conceptos

        let empleados = []

        angular.forEach(data, function (colaborador) {
          colaborador.id_nomina = $ctrl.idNomina
          colaborador.total_percepciones = 0
          colaborador.total_deducciones = 0;

          ['percepciones', 'deducciones'].forEach(function (naturaleza) {
            angular.forEach(colaborador[naturaleza], function (data, idConcepto) {
              let concepto = calcularConcepto(Number(idConcepto), data, colaborador)

              if (!concepto) {
                delete colaborador[naturaleza][idConcepto]

                return
              }

              colaborador[naturaleza][idConcepto] = concepto

              if (naturaleza === 'percepciones')
                colaborador.total_percepciones += (concepto.importe || 0)
              else
                colaborador.total_deducciones += (concepto.importe || 0)
            })
          })

          colaborador.comision_importe = parseFloat((colaborador.importe * colaborador.comision_porcentaje).toFixed(2))
          colaborador.neto = parseFloat((colaborador.importe - colaborador.comision_importe).toFixed(2))

          colaborador.total_percepciones = parseFloat((colaborador.total_percepciones).toFixed(2))
          colaborador.total_deducciones = parseFloat((colaborador.total_deducciones).toFixed(2))
          colaborador.neto_a_pagar = null

          empleados.push(colaborador)
        })

        return NominasNominaColaboradores.post($ctrl.idEmpresa, $ctrl.idNomina, empleados)
          .then(function ({data}) {
            $ctrl.empleados = $ctrl.empleados.concat(data)

            $ctrl.onChange({$event: {data: $ctrl.empleados}})
          })
          .finally(function () {
            $ctrl.actualizando = false
          })
      })
  }

  function calcularConcepto(idConcepto, config, colaborador) {
    let concepto, data

    concepto = $ctrl.conceptos.find(function (item) {
      return item.id === idConcepto
    })

    if (!concepto)
      return null

    data = angular.extend({
      importe: 0,
      gravado: 0,
      exento: 0,
      dias: 0,
      horas: 0,
    }, config)

    if (concepto.calculo)
      $parse(concepto.calculo)({data: data}, {colaborador: colaborador})

    return data.importe > 0 ? data : null
  }

  function cerrar(data) {
    $ctrl.onClose({$event: {data: data}})
  }

  function unificarColaboradores(data) {
    return data.reduce(function (indice, item) {
      let id = item.id_empresa + '-' + item.id_empleado
      let duplicado = indice[id]

      if (duplicado) {
        duplicado.importe = (duplicado.importe || 0) + (item.importe || 0)

        if(item.importe_divisa !== null){
          duplicado.importe_divisa = (duplicado.importe_divisa || 0) + item.importe_divisa
        }

        ['percepciones', 'deducciones'].forEach((naturaleza) => {
          Object.keys(item[naturaleza]).forEach((idConcepto) => {
            duplicado[naturaleza][idConcepto] = duplicado[naturaleza][idConcepto] || {}

            Object.keys(item[naturaleza][idConcepto]).forEach((campo) => {
              duplicado[naturaleza][idConcepto][campo] = (duplicado[naturaleza][idConcepto][campo] || 0) + item[naturaleza][idConcepto][campo]
            })
          })
        })
      } else {
        indice[id] = item
      }

      return indice
    }, {})
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/agregar/component.js